import { Typography } from "@mui/material";

const GuidelineInstruction = ({ text }) => {
  return <Typography variant={"subtitle1"}>{text}</Typography>;
};

export default GuidelineInstruction;
